import {ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {WfIssueDashboardLinkContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})
export class WfIssueDashboardLinkService extends BaseApiTemplateService<WfIssueDashboardLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-dashboard-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-dashboard-links/backoffice-ep';
    this.httpClient = http;
  }

  getMaxSortByDashboard(dashboardGuid: string, visa: ApiVisa): Observable<any> {
    let url = this.apiUrl + '/max-sort?guid_dashboard=' + dashboardGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/max-sort?guid_dashboard=' + dashboardGuid;
    }
    return this.httpClient.get<any>(url, this.getHttpHeader(visa));
  }
}
